import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import Honeybadger from '@honeybadger-io/js';
import 'lib/vendor_extensions/.modernizrrc.js';

window.Honeybadger = Honeybadger;
window.datadogLogs = datadogLogs;
window.datadogRum = datadogRum;



// WEBPACK FOOTER //
// ./app/javascript/packs/head_scripts.js